if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('cart-bubble__text-count')) {
                   BSS_B2B?.observer?.cartSubject?.listenCartCheckout()
                   BSS_B2B?.observer?.cartSubject?.notifyObserver('CartMutate', 'CartPriceMutate');
                }
                if (item.target.localName === "shopify-paypal-button") {
                   BSS_B2B?.observer?.cartSubject?.notifyObserver('CartMutate', 'CartPriceMutate');

                }               
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    setTimeout(() => {
        BSS_B2B?.observer?.cartSubject?.notifyObserver('CartMutate', 'CartPriceMutate');
    }, 3000)    
}